import { useState, useCallback } from "react";
/**
 * Manages unsaved changes confirmation when closing a form dialog
 *
 * @example
 * const { isDirty } = formState;
 * const {
 *   showCloseConfirmation,
 *   handleOpenChange,
 *   handleDiscardChanges,
 *   handleStay,
 * } = useFormDialogWithUnsavedChanges({
 *   isDirty,
 *   onClose: () => setDialogOpen(false)
 * });
 *
 * // In your dialog:
 * <Dialog open={open} onOpenChange={handleOpenChange}>
 *   ...
 * </Dialog>
 * <UnsavedChangesConfirmDialog
 *   open={showCloseConfirmation}
 *   onStay={handleStay}
 *   onDiscard={handleDiscardChanges}
 * />
 */ export function useFormDialogWithUnsavedChanges({ isDirty, onClose }) {
    const [showCloseConfirmation, setShowCloseConfirmation] = useState(false);
    const handleOpenChange = useCallback((newOpen)=>{
        if (!newOpen && isDirty) {
            setShowCloseConfirmation(true);
            return;
        }
        if (!newOpen) {
            onClose();
        }
    }, [
        isDirty,
        onClose
    ]);
    const handleDiscardChanges = useCallback(()=>{
        setShowCloseConfirmation(false);
        onClose();
    }, [
        onClose
    ]);
    const handleStay = useCallback(()=>{
        setShowCloseConfirmation(false);
    }, []);
    return {
        showCloseConfirmation,
        setShowCloseConfirmation,
        handleOpenChange,
        handleDiscardChanges,
        handleStay
    };
}

//# sourceMappingURL=useFormDialogWithUnsavedChanges.js.map